import { FC } from "react";

import DashboardLayout from "layouts/DashboardLayout";

import { FrameContainer } from "uikit";

import useAdminDocumentsPage from "./useAdminPayrollAndBenefitsPage";

interface Props {
  className?: string;
}

const AdminPayrollAndBenefitsPage: FC<Props> = () => {
  const { frameId } = useAdminDocumentsPage();

  return (
    <DashboardLayout>
      <>
        <FrameContainer id={frameId} />
      </>
    </DashboardLayout>
  );
};

export default AdminPayrollAndBenefitsPage;
